var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53704 11H3.46296C1.5787 11 0 9.47222 0 7.53704V3.46296C0 1.5787 1.52778 0 3.46296 0H7.53704C9.4213 0 11 1.52778 11 3.46296V7.53704C11 9.4213 9.4213 11 7.53704 11ZM3.46296 0.814815C1.98611 0.814815 0.814815 1.98611 0.814815 3.46296V7.53704C0.814815 9.01389 2.03704 10.2361 3.51389 10.2361H7.58796C9.06482 10.2361 10.287 9.01389 10.287 7.53704V3.46296C10.287 1.98611 9.06482 0.763889 7.58796 0.763889H3.46296V0.814815Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0465 5.39824C7.84279 5.39824 7.63909 5.24546 7.63909 4.99083V3.3612H6.00946C5.80575 3.3612 5.60205 3.20842 5.60205 2.95379C5.60205 2.69916 5.75483 2.54639 6.00946 2.54639H7.79187C8.14835 2.54639 8.4539 2.85194 8.4539 3.20842V4.99083C8.4539 5.19454 8.2502 5.39824 8.0465 5.39824Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00935 5.39838C5.9075 5.39838 5.80565 5.34746 5.75472 5.29653C5.60194 5.14375 5.60194 4.88912 5.75472 4.73635L7.53713 2.95394C7.68991 2.80116 7.94454 2.80116 8.09731 2.95394C8.25009 3.10672 8.25009 3.36135 8.09731 3.51412L6.31491 5.29653C6.21305 5.34746 6.1112 5.39838 6.00935 5.39838ZM4.99083 8.45394H3.20842C2.85194 8.45394 2.54639 8.14838 2.54639 7.7919V6.00949C2.54639 5.80579 2.69916 5.60209 2.95379 5.60209C3.20842 5.60209 3.3612 5.75486 3.3612 6.00949V7.69005H4.99083C5.19454 7.69005 5.39824 7.84283 5.39824 8.09746C5.39824 8.35209 5.19454 8.45394 4.99083 8.45394Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20857 8.19916C3.10672 8.19916 3.00486 8.14824 2.95394 8.09731C2.80116 7.94454 2.80116 7.68991 2.95394 7.53713L4.73635 5.75472C4.88912 5.60194 5.14375 5.60194 5.29653 5.75472C5.44931 5.9075 5.44931 6.16213 5.29653 6.31491L3.4632 8.04639C3.41227 8.14824 3.31042 8.19916 3.20857 8.19916Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/PreviewIcon.2b74f809e25a3d6be035451e7b2f51a0.svg";
export { ForwardRef as ReactComponent };